<template>
  <footer class="footer-section">
    <div class="container">
      <div class="row mb-5">
        <!-- Column 1 -->
        <div class="col-md-4 mb-4 mainfooter">
          <h6 class="footer-heading">
            <i class="fas fa-leaf me-2"></i> About Us
          </h6>
          <p class="footer-description-def">
            At Libaax Market, we connect customers with a wide range of quality
            products from trusted sellers. Our mission is to make shopping
            convenient and affordable while supporting local businesses and
            helping communities grow.
          </p>
        </div>

        <!-- Column 2 -->
        <div class="col-md-4 mb-4 mainfooter">
          <h6 class="footer-heading">
            <i class="fas fa-link me-2"></i> Quick Links
          </h6>
          <ul class="footer-links list-unstyled">
            <li><a href="#products" class="footer-link">Our Products</a></li>
            <li><a href="#partners" class="footer-link">Partners</a></li>
            <li class="nav-item cursor">
              <a class="footer-link" @click="toggleSupport">Support</a>
            </li>
          </ul>
        </div>

        <!-- Column 3 -->
        <div class="col-md-4 mb-4 mainfooter">
          <h6 class="footer-heading">
            <i class="fas fa-address-book me-2"></i> Contact Info
          </h6>
     
          <p class="footer-description">
            <i class="fas fa-phone me-2"></i>
            <a href="tel:+254741501510" class="footer-link">+254 741 501 510</a>
          </p>
          <p class="footer-description">
            <i class="fas fa-envelope me-2"></i>
            <a href="mailto:info@libaaxc.com" class="footer-link"
              >info@libaaxc.com</a
            >
          </p>
          <p class="footer-description">
            <i class="fas fa-clock me-2"></i> Mon-Sat 8 AM-6 PM
          </p>
          <div class="footer-socials">
            <a href="#" class="social-icon"
              ><i class="fab fa-facebook-f"></i
            ></a>
            <a href="#" class="social-icon"><i class="fab fa-instagram"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>

      <!-- Footer bottom -->
      <div class="footer-bottom">
        <p class="footer-copy">
          © {{ new Date().getFullYear() }} Libaax Market. All rights reserved.
        </p>
      </div>
    </div>

    <!-- WhatsApp floating button -->
    <div class="wh-api">
      <div class="wh-fixed whatsapp-pulse">
        <a
          href="https://api.whatsapp.com/send?phone=254741501510&text=Hello Libaax Market! I'd like to know more about your products."
        >
          <button class="wh-ap-btn"></button>
        </a>
      </div>
    </div>
  </footer>

  <FloatingSupport :support-open="supportOpen" @close="supportOpen = false" />
</template>

<script>
import FloatingSupport from "./Modals/FloatingSupport.vue";
export default {
  components: {
    FloatingSupport,
  },
  name: "SiteFooter",
  data() {
    return {
      supportOpen: false,
      isNavOpen: false,
    };
  },
  methods: {
    toggleSupport() {
      this.supportOpen = !this.supportOpen;
    },
  },
};
</script>

<style scoped>
.footer-section {
  background: #ecfdf5; /* soft green background */
  color: var(--primary-color); /* deep green text */
  padding: 3rem 0 1.5rem 0;
}

.footer-heading {
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.footer-description-def {
  line-height: 1.8;
  font-size: 0.95rem;
  color: #374151;
}

.footer-description {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  color: #374151;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-link {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.3s;
}
.footer-link:hover {
  color: var(--primary-color);
  text-decoration: underline;
}

.footer-socials {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
}
.social-icon {
  color: var(--primary-color);
  font-size: 1.2rem;
  transition: color 0.3s;
}
.social-icon:hover {
  color: var(--primary-color);
}

.footer-bottom {
  border-top: 1px solid #d1fae5;
  padding-top: 1rem;
  text-align: center;
}
.footer-copy {
  font-size: 0.85rem;
  color: #374151;
}

/* WhatsApp button */
button.wh-ap-btn {
  outline: none;
  width: 60px;
  height: 60px;
  border: 0;
  background-color: var(--primary-color);
  border-radius: 100%;
  cursor: pointer;
}
button.wh-ap-btn::after {
  background-image: url("//i.imgur.com/cAS6qqn.png");
  content: "";
  background-position: center;
  background-repeat: no-repeat;
  background-size: 60%;
  width: 100%;
  height: 100%;
  display: block;
}
.wh-api {
  position: fixed;
  bottom: 0;
  right: 0;
}
.wh-fixed {
  margin-right: 15px;
  margin-bottom: 15px;
}
.whatsapp-pulse {
  width: 60px;
  height: 60px;
  right: 10px;
  bottom: 10px;
  background: var(--primary-color);
  position: fixed;
  border-radius: 50%;
  z-index: 99;
}
</style>
